import { render } from "./Order.vue?vue&type=template&id=64286a92"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=64286a92&lang=scss"
script.render = render

export default script